import { Button } from '@mui/material';
import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px 30px;
  height: 85vh;
`;

const StyledButton = styled(Button)`
  width: 180px;
`;

const LeadContainer = styled.div`
  display: flex;
  gap: 1px;
  align-items: center;
  width: 100%;
`;

const LeadInfoContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  width: 100%;
  justify-content: space-between;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
`;

const dataGridStyles = {
  width: '100%',
  '& .MuiDataGrid-main': {
    overflow: 'auto !important',
  },
  '& .MuiDataGrid-virtualScroller': {
    overflow: 'auto !important',
  },
  '& .MuiDataGrid-cell': {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
};

export {
  Container,
  StyledButton,
  dataGridStyles,
  LeadContainer,
  LeadInfoContainer,
  ButtonGroup,
};
